import React, {useState} from 'react';
import {MaterialReactTable} from 'material-react-table';
import './HotelsTable.scss';
import CustomPagination from "../../../../components/CustomPagination";
import {Checkbox} from "@mui/material";
import {NO_SORT_TOOLTIP_LOCALIZATION} from "constants/tableLocalization";

const HotelsTable = ({
  filteredHotels,
  selectedHotels,
  handleCheckboxChange,
  showGroupName,
  isThirdComponent,
}) => {
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRequestSort = (columnId) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };

  // Calculate paginated data
  const hotelsCount = filteredHotels.length;
  const pageCount = Math.ceil(hotelsCount / rowsPerPage);
  const sortedRows = filteredHotels.sort((a, b) => {
    if (order === 'asc') {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  const paginatedHotels = sortedRows.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
  );

  const allSelected = paginatedHotels.length > 0 && paginatedHotels.every(hotel => selectedHotels.includes(hotel.id));
  const someSelected = paginatedHotels.some(hotel => selectedHotels.includes(hotel.id));

  // Initiate columns
  const columns = [
    {
      id: "select",
      header: (
          <Checkbox
              checked={allSelected}
              indeterminate={!allSelected && someSelected}
              onChange={() => {
                if (allSelected) {
                  const newSelected = selectedHotels.filter(id => !paginatedHotels.some(h => h.id === id));
                  handleCheckboxChange('selectAll', newSelected);
                } else {
                  const newSelected = Array.from(new Set([...selectedHotels, ...paginatedHotels.map(h => h.id)]));
                  handleCheckboxChange('selectAll', newSelected);
                }
              }}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
          />
      ),
      Cell: ({ row }) => (
          <Checkbox
              checked={selectedHotels.includes(row.original.id)}
              onChange={() => handleCheckboxChange(row.original.id)}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
          />
      ),
      enableColumnActions: false,
      enableSorting: false,
      enableFilters: false,
      size: isThirdComponent ? 15 : 20,
      columnDefType: 'display',
    },
    {
      accessorKey: "id",
      header: "Hotel ID",
      size: isThirdComponent ? 20 : 50,
    },
    {
      accessorKey: "name",
      header: "Hotel Name",
      size: isThirdComponent ? 50 : 100,
    },
    {
      accessorKey: "country",
      header: "Country",
      size: isThirdComponent ? 30 : 50,
    },
    ...(showGroupName
        ? [{
          accessorKey: "groupName",
          header: "Group Name",
          size: isThirdComponent ? 50 : 100,
          Cell: ({ cell }) => cell.getValue() || "Ungrouped",
        }]
        : []),
  ];

  return (
    <div className="custom-hotels-table-container">
      <MaterialReactTable
        localization={NO_SORT_TOOLTIP_LOCALIZATION}
        columns={columns}
        data={paginatedHotels}
        enablePagination={false}
        enableSorting={true}
        onSortingChange={(sortFn) => {
          const sortOptions = sortFn();
          handleRequestSort(sortOptions?.[0].id)
        }}
        enableColumnVisibility={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        enableColumnActions={false}
        enableColumnFilters={false}
        enableGlobalFilter={false}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        enableStickyHeader
        muiTableContainerProps={{
          sx: { boxShadow: "none", border: "none", maxHeight: "100%" },
        }}
        muiTablePaperProps={{ sx: { boxShadow: "none" } }}
        muiTableHeadCellProps={{
          sx: {
            textAlign: "left",
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "normal",
            verticalAlign: "middle",
            padding: "0 16px",
            boxShadow: "none",
            borderBottom: "1px solid #e0e0e0",
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            fontFamily: "Roboto",
            textAlign: "left",
            width: "150px",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "40px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            height: "45px",
            padding: "0 16px",
          },
        }}
        muiTableBodyRowProps={{
          sx: {
            "& td": {
              position: "static",
              zIndex: "auto",
            },
            "&:hover": {
              backgroundColor: "#FAFAFA !important",
            },
          },
        }}
      />
      <div className="buttons-container">
        {/* Pagination Component */}
        <CustomPagination
          pageCount={pageCount}
          page={page}
          handleChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={(e) => {
            setRowsPerPage(e.target.value);
            setPage(1)
          }}
        />
      </div>
    </div>
  );
};

export default HotelsTable;
